export default "__VITE_ASSET__vPsdQFcb__"